import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { OVERLAY_LAYER_GROUPS } from "./mapStyle";

const LayerControl = ({ activeLayers, onChange, showPlayers }) => (
  <UncontrolledDropdown className="vector-live-map-layer-control">
    <DropdownToggle color="secondary" size="sm" caret>
      Toggle Layers
    </DropdownToggle>
    <DropdownMenu container="body" className="vector-live-map-layer-list p-3">
      {OVERLAY_LAYER_GROUPS.filter((layer) => showPlayers || layer.id !== "players").map((layer) => (
        <div key={layer.id} className="mb-1">
          <label className="form-check form-switch form-check-custom form-check-solid">
            <input
              className="form-check-input"
              type="checkbox"
              checked={activeLayers.includes(layer.id)}
              onChange={(event) => {
                const visible = event.target.checked;
                onChange((current) =>
                  visible
                    ? [...current, layer.id]
                    : current.filter((id) => id !== layer.id)
                );
              }}
            />
            <span className="form-check-label">{layer.label}</span>
          </label>
        </div>
      ))}
    </DropdownMenu>
  </UncontrolledDropdown>
);

export default LayerControl;
